function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { useCallback, useMemo } from 'react';
import { getPositionOfSelectedItemElement, isItemElementWithDescription, isSectionElement } from "./itemUtils.js";
export function useStaticItemInitialScrollPosition(_ref) {
  var itemHeight = _ref.itemHeight,
    selectedKey = _ref.selectedKey,
    topOffset = _ref.topOffset,
    items = _ref.items;
  // Item descriptions and Section elements introduce variable item heights.
  // This throws off scroll position calculations, so we disable auto scrolling
  // if either of these are found.
  var disableScrollOnOpen = useMemo(() => items.some(item => isSectionElement(item) || isItemElementWithDescription(item)), [items]);
  var getInitialScrollPosition = useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    return disableScrollOnOpen ? topOffset : getPositionOfSelectedItemElement({
      items,
      itemHeight,
      selectedKey,
      topOffset
    });
  }), [disableScrollOnOpen, itemHeight, items, selectedKey, topOffset]);
  return getInitialScrollPosition;
}
export default useStaticItemInitialScrollPosition;
//# sourceMappingURL=useStaticItemInitialScrollPosition.js.map